import { colorsPalettes } from "@similarweb/styles";

import {
    LEARN_MORE_TEXT,
    signalInfoTextMap,
} from "app/pages/sales-intelligence/modules/company-analysis/services/signals/maps/newsSignalTextMap";
import type {
    NewsSignalEventDto,
    SignalEventDto,
} from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import TruncatedTextWithTooltip from "app/pages/sales-intelligence/pages/company-analysis/components/shared/TruncatedTextWithTooltip/TruncatedTextWithTooltip";

import SignalCompanyLink from "./SignalCompanyLink";
import { StyledSignalText } from "./styles";

type NewsSignalEventInfoProps = {
    signal: NewsSignalEventDto;
    onCompanyLinkClick: (signalEvent: SignalEventDto) => void;
};

const NewsSignalEventInfoBox = ({ signal, onCompanyLinkClick }: NewsSignalEventInfoProps) => {
    const { relatedCompanyDomain = "", categories } = signal;

    const subtype = categories[0];

    const signalInfoTextMapValue = signalInfoTextMap[subtype];

    const text = typeof signalInfoTextMapValue === "function" ? signalInfoTextMapValue(signal) : signalInfoTextMapValue;

    const handleOnCompanyLinkClick = () => onCompanyLinkClick(signal);

    if (!text) {
        return null;
    }

    return (
        <StyledSignalText data-automation="signal-event-info-news-text">
            {text === LEARN_MORE_TEXT ? (
                <>
                    <span>{`${text} `}</span>
                    <SignalCompanyLink
                        domain={relatedCompanyDomain}
                        onCompanyLinkClick={handleOnCompanyLinkClick}
                        data-automation="signal-event-info-news-company-link"
                    >
                        {relatedCompanyDomain}
                    </SignalCompanyLink>
                </>
            ) : (
                <TruncatedTextWithTooltip
                    height={16}
                    text={text}
                    textStyles={{
                        fontVariant: "input2",
                        color: colorsPalettes.carbon[250],
                    }}
                />
            )}
        </StyledSignalText>
    );
};

export default NewsSignalEventInfoBox;
